import { mergeAttributes, Node } from '@tiptap/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { Injector } from '@angular/core';
import { EditFileNodeView } from './edit-file-node-view/edit-file-node-view.component';

export const EditFileNode = (injector: Injector): Node => {
  return Node.create({
    name: 'editFileNode',
    group: 'block',
    content: 'block*',
    isolating: true,
    defining: true,
    selectable: true,

    addAttributes() {
      return {
        messageBody: {
          default: null
        },
        messageSize: {
          default: null
        }
      };
    },

    parseHTML() {
      return [];
    },

    renderHTML({ HTMLAttributes }) {
      return ['edit-file-node', mergeAttributes(HTMLAttributes), 0];
    },

    addNodeView() {
      return AngularNodeViewRenderer(EditFileNodeView, { injector });
    }
  });
};
